import { Spacing, Switch } from '@billy/design-system'
import styled from '@emotion/styled'

export const SwitchToggle = styled(Switch)`
  width: fit-content;
`

export const OrganizationFeatureItemWrapper = styled.div`
  width: 100%;

  & + & {
    margin-top: ${Spacing.S24};
  }
`

export const FeatureHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: ${Spacing.S12};
  margin-bottom: ${Spacing.S8};
`
